import { LinkButton } from '@hg/stylizator/components'
import { TResponsiveValue } from '@hg/stylizator/hooks'
import { AndroidIcon, AppleIcon, WindowsIcon } from '@hg/stylizator/icons'
import * as React from 'react'
import { osName, osVersion } from 'react-device-detect'

import useHasMounted from 'app/hooks/use-has-mounted'

export interface IAttributes {
  leftButtonWindowsText: string
  leftButtonMacosText: string
  leftButtonAndroidText: string
  leftButtoniOSText: string
  leftButtonWindowsUrl: string
  leftButtonWindows7Url: string
  leftButtonMacosUrl: string
  leftButtonAndroidUrl: string
  leftButtoniOSUrl: string
  skipUnknown?: true
  className?: string
  size?: React.ComponentProps<typeof LinkButton>['size']
  fullWidth?: TResponsiveValue<boolean>
  specialTheme?: boolean
}

const OsDownloadButton: React.FC<IAttributes> = (props) => {
  const fullWidth = props.fullWidth
  const supportedPlatforms = ['windows', 'mac', 'android']
  const operatingSystem = osName.toLowerCase()
  const type = props.specialTheme ? 'accent' : 'primary'
  const hasMounted = useHasMounted()

  const isUnknownOs =
    (operatingSystem.includes('windows') && props.leftButtonWindowsUrl === '') ||
    (operatingSystem.includes('mac') && props.leftButtonMacosUrl === '') ||
    (operatingSystem.includes('android') && props.leftButtonAndroidUrl === '') ||
    (operatingSystem.includes('ios') && props.leftButtoniOSUrl === '')

  const isSupportedPlatform = supportedPlatforms.filter((it) => operatingSystem.includes(it)).length > 0

  if (props.skipUnknown && (isUnknownOs || !isSupportedPlatform)) {
    return null
  }

  if (!hasMounted) {
    return null
  }

  if (operatingSystem.includes('windows')) {
    return (
      <LinkButton
        className={props.className}
        type={type}
        size={props.size}
        useCompact
        icon={<WindowsIcon />}
        fullWidth={fullWidth}
        href={osVersion === '7' ? props.leftButtonWindows7Url : props.leftButtonWindowsUrl}
      >
        {props.leftButtonWindowsText}
      </LinkButton>
    )
  }

  if (operatingSystem.includes('mac')) {
    return (
      <LinkButton
        className={props.className}
        type={type}
        size={props.size}
        useCompact
        icon={<AppleIcon />}
        href={props.leftButtonMacosUrl}
        fullWidth={fullWidth}
      >
        {props.leftButtonMacosText}
      </LinkButton>
    )
  }

  if (operatingSystem.includes('ios')) {
    return (
      <LinkButton
        className={props.className}
        type={type}
        size={props.size}
        useCompact
        icon={<AppleIcon />}
        href={props.leftButtoniOSUrl}
        fullWidth={fullWidth}
      >
        {props.leftButtoniOSText}
      </LinkButton>
    )
  }

  if (operatingSystem.includes('android')) {
    return (
      <LinkButton
        className={props.className}
        type={type}
        size={props.size}
        useCompact
        icon={<AndroidIcon />}
        href={props.leftButtonAndroidUrl}
        fullWidth={fullWidth}
      >
        {props.leftButtonAndroidText}
      </LinkButton>
    )
  }

  return (
    <LinkButton
      className={props.className}
      type={type}
      size={props.size}
      useCompact
      icon={<AndroidIcon />}
      href={props.leftButtonAndroidUrl}
      fullWidth={fullWidth}
    >
      {props.leftButtonAndroidText}
    </LinkButton>
  )
}

export default OsDownloadButton
